import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// サイト全体で使うもの、特定のページに限定されないもの
export default class Common {
   static getInstance() {
      if (!Common.instance) {
         Common.instance = new Common(); // 初回の呼び出し時にインスタンスを作成
      }
      return Common.instance;  // 同じインスタンスを返す
   }

   constructor() {
      this.initNavgation();
      // インスタンスを保存
      Common.instance = this;
   }

   initNavgation() {
      // ボタンとオーバーレイ要素を取得
      const triggerButton = document.getElementById('triggerButton');
      const overlay = document.getElementById('overlay');
      const closeButton = document.getElementById('closeButton');
      if (!triggerButton || !overlay || !closeButton) {
         return;
      }
      // トリガーボタンクリック時にオーバーレイを開閉
      triggerButton.addEventListener('click', function() {
         overlay.classList.toggle('hidden'); // hiddenクラスをトグルして開閉
      });
      // クローズボタンクリック時にオーバーレイを非表示
      closeButton.addEventListener('click', function() {
         overlay.classList.add('hidden'); // hiddenクラスを追加して非表示
      });

      // スクロールトリガーを使ってヘッダーを表示
      gsap.registerPlugin(ScrollTrigger);
      gsap.set('[data-scroll-hide-header-elem]', { opacity: 1 });
      gsap.to('[data-scroll-hide-header-elem]', {
         opacity: 0,
         duration: 0.3,
         ease: "power2.out",
         scrollTrigger: {
            trigger: document.body,
            start: "top+=300 top",
            toggleActions: "play none none reverse",
         }
      });
   }
};
